enum DomainsActionTypesEnum {
  SAVE_DOMAINS = 'SAVE_DOMAINS',
  SET_SELECTED_DETAILED_DOMAIN = 'SET_SELECTED_DETAILED_DOMAIN',
}

export default DomainsActionTypesEnum;
